document.addEventListener('DOMContentLoaded', () => {
    const allCollectionProducts = document.querySelectorAll('.product-item-card');

    allCollectionProducts?.forEach((collectionProduct) => {
        collectionProduct.addEventListener('click', () => {
            const productTitle = collectionProduct.querySelector('.card-information__text').innerText;
            const productPrice = collectionProduct.querySelector('.price-item').innerText;
            const product = {
                'title': productTitle,
                'price': productPrice
            }
            Shopify.analytics.publish("clic_product_category", product );
        });
    
        const productColorSelector = collectionProduct.querySelector('.card-product__colors');

        productColorSelector?.childNodes?.forEach((productColor) => {
            productColor.addEventListener('click', () => {
                const productTitle = collectionProduct.querySelector('.card-information__text').innerText;
                const productPrice = collectionProduct.querySelector('.price-item').innerText;
                const productColorSelector = {
                    'title': productTitle,
                    'price': productPrice,
                    'color': productColor.innerText ? productColor.innerText : ''
                }
                Shopify.analytics.publish("clic_color_category", productColorSelector );
            });

        });

        const productSizeSelector = collectionProduct.querySelector('.size-radios');

        productSizeSelector?.childNodes?.forEach((productSize) => {
            productSize.addEventListener('click', () => {
                const productTitle = collectionProduct.querySelector('.card-information__text').innerText;
                const productPrice = collectionProduct.querySelector('.price-item').innerText;
                const productSizeSelector = {
                    'title': productTitle,
                    'price': productPrice,
                    'size': productSize.innerText ? productSize.innerText : ''
                }
                Shopify.analytics.publish("clic_size_category", productSizeSelector );
            });
        });

        const productPrevArrow = collectionProduct.querySelector('.previous-media');
        const productNextArrow = collectionProduct.querySelector('.next-media');
        if( productPrevArrow != null ) {
            productPrevArrow.addEventListener('click', () => {
                const productTitle = collectionProduct.querySelector('.card-information__text').innerText;
                const productPrice = collectionProduct.querySelector('.price-item').innerText;
                const productPrevArrowClick = {
                    'title': productTitle,
                    'price': productPrice,
                    'click_type': 'Previous image click'
                }
                Shopify.analytics.publish("tap_image_category", productPrevArrowClick );
            });
        }
            
        if(productNextArrow != null) {
            productNextArrow.addEventListener('click', () => {
                const productTitle = collectionProduct.querySelector('.card-information__text').innerText;
                const productPrice = collectionProduct.querySelector('.price-item').innerText;
                const productNextArrowClick = {
                    'title': productTitle,
                    'price': productPrice,
                    'click_type': 'Next image click'
                }
                Shopify.analytics.publish("tap_image_category", productNextArrowClick );
            });
        }
    });

    let lastScrollPosition = 0;

    window.addEventListener('scroll', function() {
        let currentScrollPosition = window.scrollY;
        let secondRow = document.querySelector('.sticky-filters');

        if (!secondRow) return; // Exit if element doesn't exist

        let facetsWrapper = document.querySelector('.mobile-facets__open-wrapper')

        if (facetsWrapper && facetsWrapper.ariaExpanded === 'true') {
            // don't hide the second row (instead of the entire sticky-filters) when the facets are open
            return;
        }

        if (currentScrollPosition > lastScrollPosition && currentScrollPosition > 50) {
        // User is scrolling down
        secondRow.style.visibility = 'hidden';  // Hide the row visually
        secondRow.style.opacity = '0'; // Fades it out
        } else if (currentScrollPosition < lastScrollPosition) {
        // User is scrolling up
        secondRow.style.visibility = 'visible'; // Make the row visible again
        secondRow.style.opacity = '1'; // Makes it visible again
        }

        // Update the last scroll position to the current one
        lastScrollPosition = currentScrollPosition;
    });
})